// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3865ba3c","732":"56f5eb2b","977":"e65e7542"}[chunkId] + ".chunk.js";
};